import React from "react";
import { Loader2 } from "lucide-react";

export function KPI({ label, value, accent = false, icon: Icon, hint, testid }) {
  return (
    <div className="card-modav p-5 fade-up" data-testid={testid}>
      <div className="flex items-start justify-between mb-2">
        <div className="text-[11px] uppercase tracking-[0.18em] text-[#5E7166] font-bold">{label}</div>
        {Icon && <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${accent ? "bg-[#FDF6E3] text-[#C9A227]" : "bg-[#E8F5EE] text-[#0E5C3A]"}`}><Icon size={16}/></div>}
      </div>
      <div className={`text-2xl sm:text-3xl font-bold ${accent ? "naira-total" : "text-[#1A2E24]"}`}>{value}</div>
      {hint && <div className="text-xs text-[#5E7166] mt-1">{hint}</div>}
    </div>
  );
}

export function Card({ children, className = "", title, action, testid }) {
  return (
    <div className={`card-modav p-5 ${className}`} data-testid={testid}>
      {(title || action) && (
        <div className="flex items-center justify-between mb-4">
          {title && <h3 className="font-serif text-lg font-semibold text-[#1A2E24]">{title}</h3>}
          {action}
        </div>
      )}
      {children}
    </div>
  );
}

export function Loading({ label = "Loading..." }) {
  return (
    <div className="flex items-center justify-center py-12 text-[#5E7166]" data-testid="loading-spinner">
      <Loader2 className="animate-spin mr-2" size={18}/> {label}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="card-modav p-10 text-center">
      {Icon && <div className="w-14 h-14 rounded-full bg-[#E8F5EE] text-[#0E5C3A] mx-auto mb-3 flex items-center justify-center"><Icon size={22}/></div>}
      <h3 className="font-serif text-lg font-semibold text-[#1A2E24]">{title}</h3>
      {description && <p className="text-sm text-[#5E7166] mt-1 max-w-md mx-auto">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
